import React from 'react'
import pure from 'recompose/pure'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'
import injectSheet from 'react-jss'
import Textfit from 'react-textfit'
import Icon from 'aria-viewer/tour/components/icon'
import classNames from 'classnames'
import BLUR from 'public/assets/svg/hotspots/drop_blur.png'

const styleSheet = theme => ({
    blur: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        opacity: 0.7,
        backgroundImage: `url(${BLUR})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        backgroundSize: '100% 50%',
    },
    button: {
        width: 46,
        height: 46,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        borderRadius: '50%',
        zIndex: 1,
    },
    buttonMobile: {
        width: 28,
        height: 28,
        boxSizing: 'border-box',
        backgroundColor: 'transparent',
        opacity: 1,
        border: `1px solid ${theme.palette.common.white}`,
        '&:hover': {
            backgroundColor: 'initial',
        },
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 500,
        width: 124,
        height: 46,
        color: '#fff',
        textShadow: '0 2px 2px rgba(0, 0, 0, 0.3)',
        textAlign: 'right',
        zIndex: 1,
        '& div': {
            width: '100%',
        },
        paddingRight: 10,
    },
    titleMobile: {
        width: ({ useResponsiveUI }) => !useResponsiveUI && 'initial',
        marginRight: 10,
    },
    arrow: {
        position: 'relative',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 22,
        height: 16,
    },
    arrowMobile: {
        transform: 'translate(-50%, -50%) rotate(-90deg)',
    },
    clickable: {
        cursor: 'pointer',
        pointerEvents: 'all',
        position: 'relative',
        justifyContent: 'space-between',
        display: 'flex',
        width: '100%',
        height: '100%',
        userSelect: 'none',
        alignItems: 'center',
        '& > div:last-child': {
            transition: '0.2s ease-out',
        },
        '&:hover > div:last-child': {
            backgroundColor: 'rgba(0, 0, 0, 1)',
            transform: 'scale(1.1)',
        },
        width: ({ useResponsiveUI, viewportWidth }) => useResponsiveUI && (viewportWidth < 700 ? '50px' : null),
        position: ({ useResponsiveUI }) => useResponsiveUI && 'absolute',
        right: ({ useResponsiveUI }) => useResponsiveUI && '0px',
        top: ({ useResponsiveUI }) => useResponsiveUI && '15%',
    },
})

const style = injectSheet(styleSheet)

const props = withProps(({ isMobile }) => ({
    titleMax: isMobile ? 14 : 18,
    titleMin: isMobile ? 14 : 12,
    icon: isMobile ? 'arrowDown' : 'nextArrow',
    iconStyle: isMobile ? { width: 13, height: 8 } : { width: 22, height: 16 },
    isMobile: isMobile,
}))

const NextButton = ({
    classes,
    className,
    title,
    titleMin,
    titleMax,
    icon,
    iconStyle,
    isMobile,
    onClick,
    useResponsiveUI,
    viewportWidth,
}) => (
    <div className={className}>
        <div className={classes.blur} />
        <div className={classes.clickable} onClick={!useResponsiveUI && onClick}>
            {viewportWidth > 700 && (
                <Textfit
                    className={classNames(classes.title, { [classes.titleMobile]: isMobile })}
                    mode="multi"
                    max={titleMax}
                    min={titleMin}
                >
                    {title}
                </Textfit>
            )}
            <div
                className={classNames(classes.button, { [classes.buttonMobile]: isMobile })}
                onClick={useResponsiveUI && onClick}
            >
                <Icon
                    className={classNames(classes.arrow, { [classes.arrowMobile]: isMobile })}
                    icon={icon}
                    style={iconStyle}
                />
            </div>
        </div>
    </div>
)

export default compose(
    style,
    props,
    pure
)(NextButton)
